import { Component, OnInit } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import {HttpClient,HttpParams,HttpEventType,HttpResponse,HttpRequest,HttpHeaders} from '@angular/common/http';
import { environment as configs } from 'src/environments/environment';

@Component({
  selector: 'app-integrate-csc-cycle-component',
  templateUrl: './integrate-csc-cycle-component.component.html',
  styleUrls: ['./integrate-csc-cycle-component.component.css']
})
export class IntegrateCscCycleComponentComponent implements OnInit {

  host=configs['ApiHost'];
 constructor(private actRoute:ActivatedRoute,private httpClient:HttpClient,private router:Router) { }

 ngOnInit() {
   this.actRoute.params.subscribe(resp=>{
     // console.log(resp.id)
     this.httpClient.get(this.host+'/integrate/cycle/csc/'+resp.id,{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).subscribe(resp=>{
       if(resp['status']==true){
         let user={'role':resp['role'],
                   'username':resp['username'],
                   'branch':resp['branch'],
         }
         localStorage.setItem('auth-token',resp['token']);
         localStorage.setItem('user',JSON.stringify(user));
        
         
           this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:60}})
         
        

       }else{
         this.router.navigate(['login'])
       }

     })

   })
 }

}
